"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionContextProvider = exports.SessionContext = void 0;
const tslib_1 = require("tslib");
const client_core_1 = require("@sensenet/client-core");
const react_1 = tslib_1.__importStar(require("react"));
const semaphore_async_await_1 = tslib_1.__importDefault(require("semaphore-async-await"));
const hooks_1 = require("../hooks");
/**
 * Context that stores session related data
 */
exports.SessionContext = react_1.default.createContext({
    state: client_core_1.LoginState.Unknown,
    currentUser: client_core_1.ConstantContent.VISITOR_USER,
    groups: [],
});
exports.SessionContext.displayName = 'SessionContext';
/**
 * Provider component for the SessionContext.
 * Has to be wrapped with **RepositoryContext** and **LoggerContext**
 * Fills the SessionContext with data from the current repository.
 */
const SessionContextProvider = (props) => {
    const repo = hooks_1.useRepository();
    const logger = hooks_1.useLogger('SessionContext');
    const [loadLock] = react_1.useState(new semaphore_async_await_1.default(1));
    const [state, setState] = react_1.useState(client_core_1.LoginState.Unknown);
    const [user, setUser] = react_1.useState(client_core_1.ConstantContent.VISITOR_USER);
    const [groups, setGroups] = react_1.useState([]);
    react_1.useEffect(() => {
        const ac = new AbortController();
        const observables = [
            repo.authentication.state.subscribe((s) => {
                setState(s);
            }, true),
            repo.authentication.currentUser.subscribe((usr) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                logger.debug({
                    message: `Current user changed.`,
                    data: {
                        relatedRepository: repo.configuration.repositoryUrl,
                        relatedContent: usr,
                        multiple: true,
                        digestMessage: 'Current user changed {count} times',
                    },
                });
                if (usr.Id === client_core_1.ConstantContent.VISITOR_USER.Id) {
                    return;
                }
                try {
                    yield loadLock.acquire();
                    setUser(usr);
                    const result = yield repo.security.getParentGroups({
                        contentIdOrPath: usr.Id,
                        directOnly: false,
                        oDataOptions: {
                            select: ['Name'],
                        },
                        requestInit: {
                            signal: ac.signal,
                        },
                    });
                    setGroups(result.d.results);
                }
                catch (error) {
                    if (!ac.signal.aborted) {
                        setGroups([]);
                        logger.debug({
                            message: `User groups could not be loaded.`,
                            data: {
                                relatedRepository: repo.configuration.repositoryUrl,
                                relatedContent: usr,
                                error: client_core_1.isExtendedError(error) ? repo.getErrorFromResponse(error.response) : error,
                            },
                        });
                    }
                }
                finally {
                    loadLock.release();
                }
            }), true),
        ];
        repo.authentication.checkForUpdate();
        return () => {
            observables.forEach((o) => o.dispose());
            ac.abort();
        };
    }, [loadLock, logger, repo]);
    return (react_1.default.createElement(exports.SessionContext.Provider, { value: { state, currentUser: user, groups } }, props.children));
};
exports.SessionContextProvider = SessionContextProvider;
//# sourceMappingURL=session.js.map